export const AMOUNT_BY_DEFAULT_CONSTANT = '350000';
export const TERM_BY_DEFAULT_CONSTANT = '30';
